// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cxU1","newExpiryDate":"styles_newExpiryDate__FOB8n","footer":"styles_footer__20iYB"};